import { BaseContainerModel } from '../../base-container.model';
import { bl_b2b_xtn_einvoice_matching_queue_RowClass } from '../../../dbschema/index';

export class XtnEinvoiceMatchingQueueContainer extends BaseContainerModel {
  bl_b2b_xtn_einvoice_matching_queue: bl_b2b_xtn_einvoice_matching_queue_RowClass = new bl_b2b_xtn_einvoice_matching_queue_RowClass();
}
